<template>
  <div class="mc-liveview--fo clearfix">
    <SideBar
      :detailData="detailData"
      :loading="loadingDetailFO"
      :currentDateTime="currentDateTime"
    />
    <GoogleMap
      :detailData="detailData"
      :detailVehicle="detailVehicle"
      :currentDateTime="currentDateTime"
      :authToken="getAuthToken()"
      @update:currentDateTime="updateCurrentDateTime"
    />
  </div>
</template>
<script>
import appConfig from '@/app.config'
import GoogleMap from './GoogleMap'
import SideBar from './SideBar'
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'
import * as FleetTask from '@/services/rest-api/lib/fleet-task/fleet-task'
import { GET_VEHICLE_STATUS_LIVETRACK } from '@/services/api/fleet'

export default {
  page: {
    title: 'Pelacakan FO',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    SideBar,
    GoogleMap,
  },
  mixins: [Helper, MixPanel],
  data() {
    return {
      data: this.$route.params.data || null,
      uid: null,
      token: null,
      detailData: {},
      driverPhoneNo: null,
      detailVehicle: {},
      lastPosition: null,
      loadingDetailFO: true,
      interval: null,

      currentDateTime: null,
      tokenVendor: null,
    }
  },

  created() {
    this.actionAfterLoginIdentity()
    this.currentDateTime = this.getCurrentDateTime()
  },
  async mounted() {
    await this.getData()
    await this.getDetailFO()

    if (this.detailData.status.raw_type !== 'ENDED') {
      this.interval = setInterval(async () => {
        await this.getDetailFO()
        if (this.detailData.status.raw_type === 'ENDED') {
          clearInterval(this.interval)
        }
      }, 300000)
    }
  },

  methods: {
    getAuthToken() {
      return this.tokenVendor || this.token
    },
    getApolloContext() {
      const authToken = this.getAuthToken()
      return {
        headers: {
          Authorization: authToken ? `Bearer ${authToken}` : undefined,
        },
      }
    },
    getData() {
      const decodedData = atob(this.data)
      const [uidPart, tokenPart] = decodedData.split('?token=')
      const newUid = btoa(uidPart) + '&&' + this.getCompanyId()
      this.uid = btoa(newUid)
      this.token = tokenPart
    },
    async getDetailFO() {
      const res = await FleetTask.trackFO(this.uid)

      this.detailData = res.data
      const vehicleId = this.detailData.vehicle.id

      if (this.detailData.vendor.token != null) {
        this.tokenVendor = this.detailData.vendor.token
      }

      try {
        const vehicleStatusRes = await this.$apollo.query({
          query: GET_VEHICLE_STATUS_LIVETRACK,
          fetchPolicy: 'no-cache',
          context: this.getApolloContext(),
          variables: {
            filter: {
              vehicleId: parseInt(vehicleId),
            },
          },
        })

        if (!vehicleStatusRes.data.vehicleStatus.isSuccessful) {
          const data = {
            hasButton: false,
          }
          localStorage.setItem('404', JSON.stringify(data))
          this.$router.push({
            name: '404',
          })
        }

        this.lastPosition = vehicleStatusRes.data.vehicleStatus.vehicleStatus
        const modifiedData = {
          ...this.detailData,
          vehicle: {
            ...this.detailData.vehicle,
            last_postion: this.lastPosition,
          },
        }
        this.detailData = modifiedData
        this.detailVehicle = this.detailData.vehicle

        this.loadingDetailFO = false
        this.track('Track Fleet Task')
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    },
    getCurrentDateTime() {
      const now = new Date()
      const isoDateTime = now.toISOString()

      return isoDateTime
    },
    updateCurrentDateTime(val) {
      this.currentDateTime = val
    },
  },
}
</script>
